import * as XLSX from 'xlsx';
import { Subject, takeUntil } from 'rxjs';
import { Component, ElementRef, EmbeddedViewRef, HostBinding, HostListener, OnInit, OnDestroy, DoCheck, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import axios from 'src/app/Service/axios';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Location } from '@angular/common';
import moment from 'moment';
import momentJalaali from 'moment-jalaali';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { pluck } from 'rxjs';
import { NgSignaturePadOptions, SignaturePadComponent } from '@almothafar/angular-signature-pad';
declare let $: any;
@Component({
    selector: 'Refule',
    templateUrl: './refuleComponent.html',
    styles: [`

    .form-control {
        padding-top: 10px;

    }

    .form-control:disabled,
    .form-control[readonly] {
        background-color: white !important;
        opacity: 1;
    }

    td, tr > th{
        vertical-align: middle;
    }


    .signature-container{
        height: 150px;
        max-height: 150px;
        position: relative;
    }

    .signature-container > div{
        height: 100;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .signature-container > div > span{
        position: absolute;
        top: -3px;
        right: 17px;
        padding: 0 10px;
        background: white;
    }

    .signature-container > div > img{
        object-fit: contain;
    }

    signature-pad {
        background: white !important;
    }

    form > .row:not(:last-child){
        border-bottom: 1px solid transparent!important;
    }
    `
    ]
})
export class RefuleComponent implements OnInit, OnDestroy, DoCheck {
    Id: number = 0;
    refule: any[] = [];
    list_Transformation: any = [];
    lst_Equipment: any = [];
    obj_Equipment: any = {};
    totalReview: any = {};
    EditeMod: boolean = false;
    iFuelReport: any;
    bTransformation: boolean = false;
    isDelivery: boolean = false;
    isTF_Confirmation: boolean = false;
    whichImage: string = '';
    sabtModel: FormGroup = this.formBuilder.group({
        iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),
        strSession: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('Session')!)),
        strUnitID: new FormControl(),
        iKm: new FormControl(''),
        iCost: new FormControl(),
        fLiter: new FormControl(),
        fLat: new FormControl(0),
        fLon: new FormControl(0),
        strLocationCode: new FormControl(""),
        strImage: new FormControl(""),
        strDate: new FormControl(''),
        strComment: new FormControl(''),
    });
    transformationModel: FormGroup = this.formBuilder.group({
        iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),
        strSession: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('Session')!)),
        strUnitID: new FormControl('', Validators.required),
        strDelivery_FullName: new FormControl('', Validators.required),
        strDelivery_Mobile: new FormControl('', Validators.required),
        strTransferee_FullName: new FormControl('', Validators.required),
        strTransferee_Mobile: new FormControl('', Validators.required),
        strGlassesCondition: new FormControl('', Validators.required),
        strFrontCondition: new FormControl('', Validators.required),
        strRightCondition: new FormControl('', Validators.required),
        strLeftCondition: new FormControl('', Validators.required),
        strBackCondition: new FormControl('', Validators.required),
        strRoofCondition: new FormControl('', Validators.required),
        strCabinCondition: new FormControl('', Validators.required),
        strSupplies: new FormControl(''),
        strDocuments: new FormControl(''),
        strViolation: new FormControl(''),
        bSpare: new FormControl(false),
        iKM: new FormControl('', Validators.required),
        iFuel: new FormControl('0'),
        strDelivery_Signature: new FormControl('', Validators.required),
        strTransferee_Signature: new FormControl('', Validators.required),
        iCarTransformation: new FormControl(''),
        tfIndex: new FormControl('')
    });
    tf_ConfirmationModel: FormGroup = this.formBuilder.group({
        iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),
        strSession: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('Session')!)),
        iCarTransformation: new FormControl('', Validators.required),
        iDelivery_OTP: new FormControl('', Validators.required),
        iTransferee_OTP: new FormControl('', Validators.required),
        strImage_Front: new FormControl(''),
        strImage_Right: new FormControl(''),
        strImage_Left: new FormControl(''),
        strImage_Back: new FormControl(''),
        strImage_Cabin: new FormControl(''),
        tfIndex: new FormControl('')
    });
    @ViewChild('signature')
    public signaturePad!: SignaturePadComponent;
    public signaturePadOptions: NgSignaturePadOptions = {
        minWidth: 5,
        canvasWidth: 400,
        canvasHeight: 300,
        backgroundColor: 'white'
    };
    constructor(private el: ElementRef, private notifyService: NotificationService, private router: Router, public otherService: OtherService, private route: ActivatedRoute, private formBuilder: FormBuilder, private _location: Location, private gurdService: GurdServiceService, private readonly views: ViewContainerRef) {
    }
    ngOnInit(): void {
        this.route.url.pipe(pluck(0, 'path')).pipe(takeUntil(this.destroy$)).subscribe((segment: any) => {
            this.bTransformation = (segment == 'transformation' ? true : false);
            // ? *** تحویل و تحول خودرو  *** // 1
            if (this.bTransformation) {
                this.route.params.pipe(pluck('id')).pipe(takeUntil(this.destroy$)).subscribe(el => this.Id = el);
                this.getAllTransformation();
                this.getCar();
            }
            // ? *** لیست سوختگیری ها *** // 2
            if (!this.bTransformation) {
                $('#exampleModal').on('hidden.bs.modal.vehicleRecords', () => {
                    this.close();
                    this.sabtModel.reset({
                        iKm: "",
                        iCost: "",
                        fLiter: "",
                        fLat: 0,
                        fLon: 0,
                        strLocationCode: "",
                        strUnitID: this.Id,
                        iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
                        strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!)
                    });
                });
                this.route.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
                    this.Id = params['id'];
                });
                this.getAllRefule();
            }
        });
    }
    async newTransformation() {
        if (this.destroyed)
            return;
        if (this.loading)
            return;
        try {
            if (this.transformationModel.invalid)
                return this.notifyService.showError('لطفا اطلاعات ضروری را وارد کنید');
            if (!this.EditeMod) {
                $.confirm({
                    title: `آیا از ثبت اطلاعات اطمینان دارید ؟`,
                    content: '',
                    type: 'green',
                    buttons: {
                        ok: {
                            text: "ثبت",
                            btnClass: 'btn-success',
                            keys: ['enter'],
                            action: async () => {
                                if (this.destroyed)
                                    return;
                                if (this.loading)
                                    return;
                                try {
                                    $('#exampleModal').modal('hide');
                                    const resp = await this.post(`CarTransformation_Save`, this.transformationModel.value);
                                    let res = this.parse(resp.data);
                                    if (res.bError || res.iResult == 0) {
                                        $('#exampleModal').modal('show');
                                        return this.notifyService.showError(res.strError);
                                    }
                                    else {
                                        this.list_Transformation.push(res[0]);
                                        this.tFModel_PathValue();
                                        return this.notifyService.showSuccess('اطلاعات با موفقیت ثبت شد');
                                    }
                                }
                                catch (error) {
                                    if (!this.destroyed) {
                                        this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
                                    }
                                }
                            }
                        },
                        cancel: {
                            text: "لغو",
                        }
                    }
                });
            }
            else {
                $.confirm({
                    title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,
                    content: '',
                    type: 'blue',
                    buttons: {
                        ok: {
                            text: "ویرایش",
                            btnClass: 'btn-primary',
                            keys: ['enter'],
                            action: async () => {
                                if (this.destroyed)
                                    return;
                                if (this.loading)
                                    return;
                                try {
                                    $('#exampleModal').modal('hide');
                                    const resp = await this.post(`CarTransformation_Edit`, this.transformationModel.value);
                                    let res = this.parse(resp.data);
                                    if (res.bError) {
                                        $('#exampleModal').modal('show');
                                        return this.notifyService.showError(res.strError);
                                    }
                                    else {
                                        this.list_Transformation[this.transformationModel.controls['tfIndex'].value] = res[0];
                                        this.tFModel_PathValue();
                                        this.EditeMod = false;
                                        return this.notifyService.showSuccess('اطلاعات با موفقیت ثبت شد');
                                    }
                                }
                                catch (error) {
                                    if (!this.destroyed) {
                                        this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
                                    }
                                }
                            }
                        },
                        cancel: {
                            text: "لغو",
                        }
                    }
                });
            }
        }
        catch (error) {
            if (!this.destroyed) {
                this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
            }
        }
    }
    async submitConfirmation() {
        if (this.destroyed)
            return;
        if (this.loading)
            return;
        try {
            if (this.tf_ConfirmationModel.invalid)
                return this.notifyService.showError('لطفا اطلاعات ضروری را وارد کنید');
            $('#exampleModal_3').modal('hide');
            const resp = await this.post(`CarTransformation_Save_Final`, this.tf_ConfirmationModel.value);
            let res = this.parse(resp.data);
            if ((res.bError || res?.strError != '') && res?.strError != null) {
                $('#exampleModal_3').modal('show');
                return this.notifyService.showError(res.strError);
            }
            else {
                this.tFC_PathValue();
                this.list_Transformation[this.tf_ConfirmationModel.controls['tfIndex'].value].tiStatus = 1;
                return this.notifyService.showSuccess('اطلاعات با موفقیت ثبت شد');
            }
        }
        catch (error) {
            if (!this.destroyed) {
                this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
            }
        }
    }
    async openModal_Operation(item: any, index: number) {
        if (this.destroyed)
            return;
        if (this.loading)
            return;
        try {
            if (item.tiStatus == 0) {
                this.isTF_Confirmation = true;
                this.tFC_PathValue();
                this.tf_ConfirmationModel.controls['tfIndex'].setValue(index);
                this.tf_ConfirmationModel.controls['iCarTransformation'].setValue(item.iCarTransformation);
                $('#exampleModal_3').modal('show');
            }
            if (item.tiStatus == 1) {
                let model = {
                    ...this.tf_ConfirmationModel.value,
                    iCarTransformation: item.iCarTransformation,
                };
                this.isTF_Confirmation = false;
                const resp = await this.post(`CarTransformation_Images`, this.otherService.stringNumberToNumber(model));
                let res = this.parse(resp.data);
                Object.keys(res).forEach(key => {
                    this.tf_ConfirmationModel.get(key)?.setValue(res[key]);
                });
                $('#exampleModal_3').modal('show');
            }
        }
        catch (error) {
            if (!this.destroyed) {
                this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
            }
        }
    }
    drawComplete(signature: any) {
        if (this.viewOnly || this.loading || this.destroyed)
            return;
        var base64Signature = signature.toDataURL();
        if (this.isDelivery)
            this.transformationModel.controls['strDelivery_Signature'].setValue(base64Signature.replace('data:image/png;base64,', ''));
        else
            this.transformationModel.controls['strTransferee_Signature'].setValue(base64Signature.replace('data:image/png;base64,', ''));
    }
    tFModel_PathValue() {
        this.transformationModel.patchValue({
            strTransferee_FullName: '',
            strTransferee_Mobile: '',
            strGlassesCondition: 'سالم',
            strFrontCondition: 'سالم',
            strRightCondition: 'سالم',
            strLeftCondition: 'سالم',
            strBackCondition: 'سالم',
            strRoofCondition: 'سالم',
            strCabinCondition: 'سالم',
            strSupplies: '',
            strDocuments: '',
            bSpare: false,
            iKM: '',
            iFuel: 0,
            strViolation: '',
            strDelivery_Signature: '',
            strTransferee_Signature: '',
        });
        this.transformationModel.controls['bSpare'].setValue(false);
    }
    tFC_PathValue() {
        this.tf_ConfirmationModel.patchValue({
            iCarTransformation: '',
            iDelivery_OTP: '',
            iTransferee_OTP: '',
            strImage_Front: '',
            strImage_Right: '',
            strImage_Left: '',
            strImage_Back: '',
            strImage_Cabin: '',
        });
    }
    seprator(e: any) {
        if (isNaN(e.key)) {
            return false;
        }
        this.otherService.insertComma(e);
        return true;
    }
    goBack() {
        this._location.back();
    }
    getAllRefule = async () => {
        if (this.destroyed)
            return;
        if (this.listLoading)
            return;
        this.listLoading = true;
        this.hasError = false;
        this.errorMessage = '';
        try {
            var model = {
                strUnitID: this.Id,
                iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
                strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),
            };
            const resp = await this.post(`FuelReport_List`, model);
            resp.data = this.parse(resp.data);
            if (resp.data) {
                this.refule = this.requireRows(resp.data);
                this.totalReview.totalCost = 0;
                this.totalReview.totalL = 0;
                this.refule.forEach((element: any) => {
                    this.totalReview.totalCost += element.iCost;
                    this.totalReview.totalL += element.fLiter;
                });
            }
        }
        catch (error) {
            if (!this.destroyed) {
                this.hasError = true;
                this.errorMessage = error instanceof Error ? error.message : 'دریافت اطلاعات ناموفق بود';
                this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
            }
        }
        finally {
            this.listLoading = false;
        }
    };
    getAllTransformation = async () => {
        if (this.destroyed)
            return;
        if (this.listLoading)
            return;
        this.listLoading = true;
        this.hasError = false;
        this.errorMessage = '';
        try {
            var model = {
                strUnitID: this.Id,
                iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
                strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),
            };
            const resp = await this.post(`CarTransformation_List`, model);
            let res = this.parse(resp.data);
            this.list_Transformation = this.requireRows(res);
            this.transformationModel.controls['strUnitID'].setValue(this.Id);
            this.transformationModel.controls['bSpare'].setValue(false);
        }
        catch (error) {
            if (!this.destroyed) {
                this.hasError = true;
                this.errorMessage = error instanceof Error ? error.message : 'دریافت اطلاعات ناموفق بود';
                this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
            }
        }
        finally {
            this.listLoading = false;
        }
    };
    getCar = async () => {
        if (this.destroyed)
            return;
        try {
            var model = {
                ID: this.gurdService.decrypt(localStorage.getItem('ID')!),
                iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
                strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
                strUnitID: this.Id,
            };
            const resp = await this.post(`GetCar?strUnitID=${this.Id}`, model);
            if (resp.data.ISSessionExpired == true) {
                this.otherService.removeLocalStorage();
                this.router.navigate(['login'], { queryParams: { error: '12' } });
                return;
            }
            if (resp.data == null) {
                this.notifyService.showError('بروز خطا در سامانه');
                return;
            }
            else {
                this.transformationModel.patchValue({
                    strDelivery_FullName: resp.data.strFullName,
                    strDelivery_Mobile: resp.data.strMobile,
                });
            }
        }
        catch (error) {
            if (!this.destroyed) {
                this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
            }
        }
    };
    sabt = async () => {
        if (this.destroyed)
            return;
        if (this.loading)
            return;
        try {
            var model = this.sabtModel.value;
            model.strUnitId = this.Id;
            if (model.strDate == null || model.strDate == '') {
                this.notifyService.showError('تاریخ را وارد کنید');
                return;
            }
            if (model.iCost == null || model.iCost == '' || model.iCost <= 0) {
                this.notifyService.showError('لطفا مقدار هزینه را وارد کنید');
                return;
            }
            if (model.fLiter == null || model.fLiter == '' || model.fLiter <= 0) {
                this.notifyService.showError('لطفا مقدار حجم سوخت گیری را وارد کنید');
                return;
            }
            model.iKm = model.iKm == '' ? 0 : model.iKm;
            // model.iCost = parseFloat(model.iCost.replace(/,/g, ''));
            // model.fLiter = parseFloat(model.fLiter.replace(/,/g, ''));
            if (confirm('آیا از ثبت اطلاعات اطمینان دارید؟')) {
                const resp = await this.post(`FuelReport_Save`, this.otherService.stringNumberToNumber(model));
                resp.data = this.parse(resp.data);
                if (resp.data.iResult == 0) {
                    this.notifyService.showError(resp.data.strError);
                    return;
                }
                if (resp.data.ISSessionExpired == true) {
                    this.notifyService.showError('لطفا وارد سیستم شوید');
                    this.otherService.removeLocalStorage();
                    this.router.navigate(['login']);
                    return;
                }
                if (resp.data.iResult == 1) {
                    this.notifyService.showSuccess('با موفقیت ثبت شد');
                    this.getAllRefule();
                    this.sabtModel.reset({
                        iKm: "",
                        iCost: "",
                        fLiter: "",
                        fLat: 0,
                        fLon: 0,
                        strLocationCode: "",
                        strUnitID: this.Id,
                        iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
                        strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!)
                    });
                    $('#exampleModal').modal('hide');
                }
            }
        }
        catch (error) {
            if (!this.destroyed) {
                this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
            }
        }
    };
    getSingel = async (Id: any) => {
        if (this.destroyed)
            return;
        if (this.loading)
            return;
        try {
            this.sabtModel.controls['iCost'].setValue(this.refule[Id].iCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
            this.sabtModel.controls['strLocationCode'].setValue(this.refule[Id].strLocationCode);
            this.sabtModel.controls['iKm'].setValue(this.refule[Id].iKm.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
            this.sabtModel.controls['fLiter'].setValue(this.refule[Id].fLiter.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
            this.sabtModel.patchValue({
                strImage: this.refule[Id].strImage,
                strDate: this.refule[Id].strDate,
                strComment: this.refule[Id].strComment || '',
                fLat: this.refule[Id].fLat || 0,
                fLon: this.refule[Id].fLon || 0,
            });
            $('#exampleModal').modal('show');
            this.iFuelReport = this.refule[Id].iFuelReport;
            this.EditeMod = true;
        }
        catch (error) {
            if (!this.destroyed) {
                this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
            }
        }
    };
    edit = async () => {
        if (this.destroyed)
            return;
        if (this.loading)
            return;
        try {
            var model = this.sabtModel.value;
            model.strUnitId = this.Id;
            model.iFuelReport = this.iFuelReport;
            if (model.strDate == null || model.strDate == '') {
                this.notifyService.showError('تاریخ را وارد کنید');
                return;
            }
            if (model.iCost == null || model.iCost == '' || model.iCost <= 0) {
                this.notifyService.showError('لطفا مقدار هزینه را وارد کنید');
                return;
            }
            if (model.fLiter == null || model.fLiter == '' || model.fLiter <= 0) {
                this.notifyService.showError('لطفا مقدار حجم سوخت گیری را وارد کنید');
                return;
            }
            model.iKm = model.iKm == '' ? 0 : model.iKm;
            // model.iCost = parseFloat(model.iCost.replace(/,/g, ''));
            // model.fLiter = parseFloat(model.fLiter.replace(/,/g, ''));
            if (confirm('آیا از ویرایش اطلاعات اطمینان دارید؟')) {
                const resp = await this.post(`FuelReport_Edit`, this.otherService.stringNumberToNumber(model));
                resp.data = this.parse(resp.data);
                if (resp.data.iResult == 0) {
                    this.notifyService.showError(resp.data.strError);
                    return;
                }
                if (resp.data.ISSessionExpired == true) {
                    this.notifyService.showError('لطفا وارد سیستم شوید');
                    this.otherService.removeLocalStorage();
                    this.router.navigate(['login']);
                    return;
                }
                if (resp.data.iResult == 1) {
                    this.notifyService.showSuccess('با موفقیت ثبت شد');
                    this.getAllRefule();
                    this.sabtModel.reset({
                        iKm: "",
                        iCost: "",
                        fLiter: "",
                        fLat: 0,
                        fLon: 0,
                        strLocationCode: "",
                        strUnitID: this.Id,
                        iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
                        strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!)
                    });
                    $('#exampleModal').modal('hide');
                }
            }
        }
        catch (error) {
            if (!this.destroyed) {
                this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
            }
        }
    };
    deleteRefule = async () => {
        if (this.destroyed)
            return;
        if (this.loading)
            return;
        try {
            if (confirm('آیا از حذف اطلاعات اطمینان دارید؟')) {
                var model = {
                    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
                    strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),
                    iFuelReport: this.iFuelReport,
                };
                const resp = await this.post(`FuelReport_Delete`, model);
                resp.data = this.parse(resp.data);
                if (resp.data.iResult == 0) {
                    this.notifyService.showError(resp.data.strError);
                    return;
                }
                if (resp.data.ISSessionExpired == true) {
                    this.notifyService.showError('لطفا وارد سیستم شوید');
                    this.otherService.removeLocalStorage();
                    this.router.navigate(['login']);
                    return;
                }
                if (resp.data.iResult == 1) {
                    this.notifyService.showSuccess('با موفقیت حذف شد');
                    this.refule = this.refule.filter((el: any) => {
                        return el.iFuelReport != this.iFuelReport;
                    });
                    $('#exampleModal').modal('hide');
                }
            }
        }
        catch (error) {
            if (!this.destroyed) {
                this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
            }
        }
    };
    close() {
        this.EditeMod = false;
    }
    open() {
        if (this.loading)
            return;
        this.viewOnly = false;
        this.whichImage = '';
        this.tFModel_PathValue();
        this.close();
    }
    guid(Id: any) {
        this.otherService.guid(Id);
    }
    onFileInput(file: any) {
        if (!file || this.loading || this.destroyed)
            return;
        let extension = file.name.split('.').pop()?.toLowerCase();
        if (extension !== 'jpeg' && extension !== 'jpg')
            this.notifyService.showError(' فرمت قابل قبول فقط jpg است');
        if (extension === 'jpeg' || extension === 'jpg') {
            const reader: any = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = async () => {
                if (this.destroyed)
                    return;
                if (this.loading)
                    return;
                try {
                    if (this.destroyed)
                        return;
                    var base64String = reader.result.toString();
                    base64String = base64String.replace('data:image/jpeg;base64,', '');
                    if (this.whichImage != '')
                        this.tf_ConfirmationModel.controls[this.whichImage].setValue(base64String);
                    else
                        this.sabtModel.controls['strImage'].setValue(base64String);
                }
                catch (error) {
                    if (!this.destroyed) {
                        this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
                    }
                }
            };
        }
    }
    showFactor(item: any) {
        $.confirm({
            title: 'فاکتور',
            content: `<img src="data:image/jpeg;base64,${item.strImage}" alt="Your Image">`,
            type: 'blue',
            buttons: {
                cancel: {
                    text: "بستن",
                }
            }
        });
    }
    async openEditModal(item: any, index: number, status?: 'showMode') {
        if (this.destroyed)
            return;
        if (this.loading)
            return;
        try {
            var model = {
                iCarTransformation: item.iCarTransformation,
                iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
                strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),
            };
            const resp = await this.post(`CarTransformation_Signatures`, model);
            let res = this.parse(resp.data);
            this.transformationModel.controls['iCarTransformation'].setValue(item.iCarTransformation);
            const newItem = Object.assign(res, item, {});
            Object.keys(newItem).forEach(key => {
                this.transformationModel.get(key)?.setValue(newItem[key]);
            });
            this.transformationModel.controls['tfIndex'].setValue(index);
            this.EditeMod = true;
            $('#exampleModal').modal('show');
            this.viewOnly = status === 'showMode';
        }
        catch (error) {
            if (!this.destroyed) {
                this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
            }
        }
    }
    async removeTransportation(item: any, index: number) {
        if (this.destroyed)
            return;
        if (this.loading)
            return;
        try {
            $.confirm({
                title: `آیا از حذف اطمینان دارید ؟`,
                content: '',
                type: 'red',
                buttons: {
                    ok: {
                        text: "حذف",
                        btnClass: 'btn-danger',
                        keys: ['enter'],
                        action: async () => {
                            if (this.destroyed)
                                return;
                            if (this.loading)
                                return;
                            try {
                                var model = {
                                    iCarTransformation: item.iCarTransformation,
                                    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
                                    strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),
                                };
                                const resp = await this.post(`CarTransformation_Delete`, model);
                                let res = this.parse(resp.data);
                                if (res.bError)
                                    return this.notifyService.showError(res.strError);
                                this.list_Transformation.splice(index, 1);
                                return this.notifyService.showSuccess('اطلاعات با موفقیت ثبت شد');
                            }
                            catch (error) {
                                if (!this.destroyed) {
                                    this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
                                }
                            }
                        }
                    },
                    cancel: {
                        text: "لغو",
                    }
                }
            });
        }
        catch (error) {
            if (!this.destroyed) {
                this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
            }
        }
    }
    async openList_Modal(item: any, i: number) {
        if (this.destroyed)
            return;
        if (this.loading)
            return;
        try {
            this.obj_Equipment = item;
            var model = {
                iCarTransformation: item.iCarTransformation,
                iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
                strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),
            };
            const resp = await this.post(`CarTrans_EquipmentDelivered_List`, model);
            let res = this.parse(resp.data);
            if (res.bError)
                return this.notifyService.showError(res.strError);
            this.lst_Equipment = res;
            $("#Equipment_Modal").modal("show");
        }
        catch (error) {
            if (!this.destroyed) {
                this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
            }
        }
    }
    openAddEquipment(model?: any) {
        $("#Equipment_Modal").modal("hide");
        if (model?.strTitle) {
            setTimeout(() => {
                $('input[name=value1]').val(model?.strTitle);
                $('input[name=value2]').val(model?.strValue);
            }, 10);
        }
        $.confirm({
            title: model ? 'ویرایش' : 'افزودن اقلام جدید',
            content: '' +
                '<form action="" class="formName">' +
                '<div class="form-group">' +
                '<label> عنوان </label>' +
                '<input type="text" name="value1" class="form-control" required>' +
                '</div>' +
                '<div class="form-group">' +
                '<label> مقدار </label>' +
                '<input type="text" name="value2" class="form-control" required>' +
                '</div>' +
                '</form>',
            buttons: {
                ok: {
                    text: model ? 'ویرایش' : "ذخیره",
                    btnClass: model ? 'btn-primary' : 'btn-success',
                    keys: ['enter'],
                    action: async () => {
                        if (this.destroyed)
                            return;
                        if (this.loading)
                            return;
                        try {
                            var value1 = $('input[name=value1]').val();
                            var value2 = $('input[name=value2]').val();
                            if (value1.trim() == '' || value2.trim() == '') {
                                this.openAddEquipment();
                                return this.notifyService.showError('لطفا مقادیر ضروری را وارد کنید');
                            }
                            else {
                                if (model) {
                                    let model_2 = {
                                        iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
                                        strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),
                                        ...model,
                                        strTitle: $('input[name=value1]').val(),
                                        strValue: $('input[name=value2]').val()
                                    };
                                    const resp = await this.post(`CarTrans_EquipmentDelivered_Edit`, this.otherService.stringNumberToNumber(model_2));
                                    let res = this.parse(resp.data);
                                    if (res.bError || res.iResult == 0) {
                                        $("#Equipment_Modal").modal("show");
                                        return this.notifyService.showError(res.strError);
                                    }
                                    this.lst_Equipment[model.index] = res[0];
                                    $("#Equipment_Modal").modal("show");
                                    this.notifyService.showSuccess('با موفقیت ویرایش شد');
                                }
                                else {
                                    let model = {
                                        iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
                                        strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),
                                        iCarTransformation: this.obj_Equipment.iCarTransformation,
                                        strTitle: $('input[name=value1]').val(),
                                        strValue: $('input[name=value2]').val()
                                    };
                                    const resp = await this.post(`CarTrans_EquipmentDelivered_Save`, this.otherService.stringNumberToNumber(model));
                                    let res = this.parse(resp.data);
                                    if (res.bError || res.iResult == 0)
                                        return this.notifyService.showError(res.strError);
                                    this.lst_Equipment.push(res[0]);
                                    $("#Equipment_Modal").modal("show");
                                    this.notifyService.showSuccess('با موفقیت اضافه شد');
                                }
                            }
                        }
                        catch (error) {
                            if (!this.destroyed) {
                                this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
                            }
                        }
                    }
                },
                cancel: {
                    text: "لغو",
                    action: async () => {
                        if (this.destroyed)
                            return;
                        if (this.loading)
                            return;
                        try {
                            $("#Equipment_Modal").modal("show");
                        }
                        catch (error) {
                            if (!this.destroyed) {
                                this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
                            }
                        }
                    }
                }
            }
        });
    }
    edit_Equipment(item: any, index: number) {
        this.openAddEquipment({ index: index, ...item });
    }
    async remove_Equipment(item: any, index: number) {
        if (this.destroyed)
            return;
        if (this.loading)
            return;
        try {
            $.confirm({
                title: `آیا از حذف اطمینان دارید ؟`,
                content: '',
                type: 'red',
                buttons: {
                    ok: {
                        text: "حذف",
                        btnClass: 'btn-danger',
                        keys: ['enter'],
                        action: async () => {
                            if (this.destroyed)
                                return;
                            if (this.loading)
                                return;
                            try {
                                var model = {
                                    iCarTrans_EquipmentDelivered: item.iCarTrans_EquipmentDelivered,
                                    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
                                    strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),
                                };
                                const resp = await this.post(`CarTrans_EquipmentDelivered_Delete`, model);
                                let res = this.parse(resp.data);
                                if (res.bError || res.iResult == 0)
                                    return this.notifyService.showError(res.strError);
                                this.lst_Equipment.splice(index, 1);
                                this.notifyService.showSuccess('با موفقیت حذف شد');
                            }
                            catch (error) {
                                if (!this.destroyed) {
                                    this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
                                }
                            }
                        }
                    },
                    cancel: {
                        text: "لغو",
                    }
                }
            });
        }
        catch (error) {
            if (!this.destroyed) {
                this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
            }
        }
    }
    async confirm_LastList() {
        if (this.destroyed)
            return;
        if (this.loading)
            return;
        try {
            $.confirm({
                title: `آیا از انجام این عملیات اطمینان دارید ؟`,
                content: '',
                type: 'blue',
                buttons: {
                    ok: {
                        text: "بارگذاری",
                        btnClass: 'btn-primary',
                        keys: ['enter'],
                        action: async () => {
                            if (this.destroyed)
                                return;
                            if (this.loading)
                                return;
                            try {
                                var model = {
                                    iCarTransformation: this.obj_Equipment.iCarTransformation,
                                    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
                                    strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),
                                };
                                const resp = await this.post(`CarTrans_EquipmentDelivered_LastList`, model);
                                let res = this.parse(resp.data);
                                if (res.bError || res.iResult == 0)
                                    return this.notifyService.showError(res.strError);
                                this.lst_Equipment = res;
                                this.notifyService.showSuccess('عملیات با موفقیت انجام شد');
                            }
                            catch (error) {
                                if (!this.destroyed) {
                                    this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
                                }
                            }
                        }
                    },
                    cancel: {
                        text: "لغو",
                    }
                }
            });
        }
        catch (error) {
            if (!this.destroyed) {
                this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
            }
        }
    }
    private readonly destroy$ = new Subject<void>();
    private destroyed = false;
    private pendingRequests = 0;
    private listLoading = false;
    hasError = false;
    errorMessage = '';
    get loading(): boolean { return this.pendingRequests > 0 || this.listLoading; }
    get tableLoading(): boolean { return this.listLoading; }
    @ViewChild('rowMoreMenu') private rowMenuTemplate!: TemplateRef<unknown>;
    rowMenuRow: Record<string, unknown> | null = null;
    private rowMenuView?: EmbeddedViewRef<unknown>;
    private rowMenuElement?: HTMLElement;
    private rowMenuTrigger?: HTMLElement;
    private readonly onMenuScroll = () => this.closeRowMenu(false);

    toggleRowMenu(event: Event, row: Record<string, unknown>): void {
        if (this.loading || this.destroyed) return;
        const alreadyOpen = this.rowMenuRow === row;
        this.closeRowMenu(false);
        if (alreadyOpen) return;
        const trigger = event.currentTarget;
        if (!(trigger instanceof HTMLElement)) return;
        this.rowMenuTrigger = trigger;
        this.rowMenuRow = row;
        this.rowMenuView = this.views.createEmbeddedView(this.rowMenuTemplate);
        this.rowMenuView.detectChanges();
        const menu = this.rowMenuView.rootNodes.find(node => node instanceof HTMLElement) as HTMLElement | undefined;
        if (!menu) { this.closeRowMenu(false); return; }
        this.rowMenuElement = menu;
        document.body.appendChild(menu);
        const page = trigger.closest<HTMLElement>('.table-page');
        if (page) menu.style.fontFamily = getComputedStyle(page).fontFamily;
        const card = trigger.closest<HTMLElement>('.card')?.getBoundingClientRect();
        const leftEdge = Math.max(8, (card?.left ?? 0) + 8);
        const rightEdge = Math.min(innerWidth - 8, (card?.right ?? innerWidth) - 8);
        const availableWidth = Math.max(1, rightEdge - leftEdge);
        menu.style.minWidth = `${Math.min(150, availableWidth)}px`;
        menu.style.maxWidth = `${availableWidth}px`;
        const rect = trigger.getBoundingClientRect();
        const width = menu.offsetWidth;
        const height = menu.offsetHeight;
        menu.style.left = `${Math.max(leftEdge, Math.min(rect.right - width, rightEdge - width))}px`;
        menu.style.top = `${rect.bottom + height + 6 <= innerHeight ? rect.bottom + 6 : Math.max(8, rect.top - height - 6)}px`;
        document.addEventListener('scroll', this.onMenuScroll, true);
        menu.querySelector<HTMLButtonElement>('button:not(:disabled)')?.focus();
    }

    closeRowMenu(restoreFocus = true): void {
        const trigger = this.rowMenuTrigger;
        document.removeEventListener('scroll', this.onMenuScroll, true);
        this.rowMenuView?.destroy();
        this.rowMenuElement?.remove();
        this.rowMenuView = undefined;
        this.rowMenuElement = undefined;
        this.rowMenuTrigger = undefined;
        this.rowMenuRow = null;
        if (restoreFocus && trigger?.isConnected) trigger.focus();
    }

    onRowMenuKeydown(event: KeyboardEvent): void {
        if (event.key === 'Tab') { this.closeRowMenu(); return; }
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const buttons = Array.from(this.rowMenuElement?.querySelectorAll<HTMLButtonElement>('button:not(:disabled)') ?? []);
        if (!buttons.length) return;
        const current = buttons.indexOf(document.activeElement as HTMLButtonElement);
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1
            : (current + (event.key === 'ArrowDown' ? 1 : -1) + buttons.length) % buttons.length;
        buttons[index].focus();
    }

    @HostListener('document:click', ['$event'])
    onOutsideRowMenuClick(event: Event): void {
        if (this.rowMenuRow && event.target instanceof Node && !this.rowMenuElement?.contains(event.target)
            && !this.rowMenuTrigger?.contains(event.target)) this.closeRowMenu(false);
    }

    @HostListener('document:keydown.escape')
    onRowMenuEscape(): void { this.closeRowMenu(); }

    @HostListener('window:resize')
    onRowMenuResize(): void { this.closeRowMenu(false); }

    viewOnly = false;
    prepareSignature(delivery: boolean): void {
        if (this.viewOnly || this.loading)
            return;
        this.isDelivery = delivery;
        this.signaturePad.clear();
    }
    async onRecordAction(key: string, row: Record<string, unknown>): Promise<void> {
        if (this.loading || this.destroyed)
            return;
        this.closeRowMenu(false);
        const rows = this.bTransformation ? this.list_Transformation : this.refule;
        const index = rows.indexOf(row);
        if (index < 0)
            return;
        if (!this.bTransformation) {
            if (key === 'details')
                await this.getSingel(index);
            if (key === 'invoice')
                this.showFactor(row);
            return;
        }
        if (key === 'details')
            await this.openEditModal(row, index, 'showMode');
        if (key === 'edit' && Number(row['tiStatus']) === 0)
            await this.openEditModal(row, index);
        if (key === 'delete' && Number(row['tiStatus']) === 0)
            await this.removeTransportation(row, index);
        if (key === 'images' || (key === 'confirm' && Number(row['tiStatus']) === 0))
            await this.openModal_Operation(row, index);
        if (key === 'equipment')
            await this.openList_Modal(row, index);
    }

    searchText = '';
    currentPage = 1;
    pageSize = 20;
    readonly pageSizeOptions = [10, 20, 50];
    filteredRows: Record<string, unknown>[] = [];
    pagedRows: Record<string, unknown>[] = [];
    totalAmount = 0;
    totalFuel = 0;
    private tableSnapshot: unknown[] = [];
    private tableIdentity = '';
    get tableTitle(): string { return this.bTransformation ? 'تحویل و تحول خودرو' : 'لیست سوخت‌گیری‌ها'; }
    get printId(): string { return `refuel-print-${this.Id}-${this.bTransformation}`; }
    get hasActiveFilters(): boolean { return !!this.searchText.trim(); }
    get emptyTitle(): string {
        return this.hasActiveFilters ? 'با این فیلترها نتیجه‌ای پیدا نشد!' : 'اطلاعاتی برای نمایش وجود ندارد';
    }

    ngDoCheck(): void {
        const identity = `${this.Id}-${this.bTransformation}`;
        const rows = this.bTransformation ? this.list_Transformation : this.refule;
        const identityChanged = identity !== this.tableIdentity;
        if (identityChanged) this.searchText = '';
        if (identityChanged || rows.length !== this.tableSnapshot.length || rows.some((row, index) => row !== this.tableSnapshot[index])) {
            this.tableIdentity = identity;
            this.refreshTable(true);
        }
    }

    onSearchChange(): void {
        if (!this.loading) this.refreshTable(true);
    }

    clearSearch(): void {
        if (this.loading) return;
        this.searchText = '';
        this.refreshTable(true);
    }

    onPageChange(page: number): void {
        if (this.loading) return;
        this.currentPage = page;
        this.refreshTable();
    }

    onPageSizeChange(size: number): void {
        if (this.loading || !this.pageSizeOptions.includes(size)) return;
        this.pageSize = size;
        this.refreshTable(true);
    }

    numberValue(value: unknown): number {
        const number = Number(value);
        return Number.isFinite(number) ? number : 0;
    }

    private normalizeSearch(value: unknown): string {
        return String(value ?? '').replace(/[۰-۹]/g, digit => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(digit)))
            .replace(/[٠-٩]/g, digit => String('٠١٢٣٤٥٦٧٨٩'.indexOf(digit))).trim().toLowerCase();
    }

    private refreshTable(resetPage = false): void {
        const rows = this.bTransformation ? this.list_Transformation : this.refule;
        this.tableSnapshot = [...rows];
        const fields = this.bTransformation ? ["strDelivery_FullName","strDelivery_Mobile","strTransferee_FullName","strTransferee_Mobile","strDate","strTime","strStatus"] : ["strUserSaved","strDate","iCost","fLiter","iKm"];
        const query = this.normalizeSearch(this.searchText);
        this.filteredRows = query
            ? rows.filter(row => this.normalizeSearch(fields.map(field => row[field]).join(' ')).includes(query))
            : [...rows];
        this.currentPage = resetPage ? 1 : Math.max(1, Math.min(this.currentPage, Math.ceil(this.filteredRows.length / this.pageSize) || 1));
        this.pagedRows = this.filteredRows.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
        this.totalAmount = this.filteredRows.reduce((sum, row) => sum + this.numberValue(row['iCost']), 0);
        this.totalFuel = this.filteredRows.reduce((sum, row) => sum + this.numberValue(row['fLiter']), 0);
    }

    exportExcel(): void {
        if (this.loading || this.hasError || !this.filteredRows.length) return;
        const headers = this.bTransformation ? ["#","تحویل‌دهنده","موبایل تحویل‌دهنده","تحویل‌گیرنده","موبایل تحویل‌گیرنده","تاریخ ثبت","زمان ثبت","وضعیت"] : ["#","کاربر ثبت‌کننده","تاریخ","مبلغ (ریال)","سوخت (لیتر)","کیلومتر"];
        const rows: (string | number)[][] = this.filteredRows.map((row, index) =>
            [index + 1, ...(this.bTransformation ? [String(row['strDelivery_FullName'] ?? ''), String(row['strDelivery_Mobile'] ?? ''), String(row['strTransferee_FullName'] ?? ''), String(row['strTransferee_Mobile'] ?? ''), String(row['strDate'] ?? ''), String(row['strTime'] ?? ''), String(row['strStatus'] ?? '')] : [String(row['strUserSaved'] ?? ''), String(row['strDate'] ?? ''), this.numberValue(row['iCost']), this.numberValue(row['fLiter']), this.numberValue(row['iKm'])])]);
        rows.push([`تعداد کل: ${this.filteredRows.length}`, ...(this.bTransformation ? Array(7).fill('') : ['', '', this.totalAmount, this.totalFuel, ''])]);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, XLSX.utils.aoa_to_sheet([headers, ...rows]), 'Sheet1');
        XLSX.writeFile(workbook, `${this.tableTitle}.xlsx`);
    }

    private parse(data: unknown): ReturnType<typeof JSON.parse> {
        return typeof data === 'string' ? JSON.parse(data) : data;
    }
    private requireRows(data: unknown): Record<string, unknown>[] {
        const parsed = this.parse(data);
        if (!Array.isArray(parsed))
            throw new Error(parsed?.strError || 'پاسخ سرور نامعتبر است');
        return parsed;
    }
    private async post(url: string, payload?: unknown) {
        if (this.destroyed)
            throw new Error('درخواست لغو شد');
        this.pendingRequests++;
        try {
            const response = await axios.post(url, payload);
            if (this.destroyed)
                throw new Error('درخواست لغو شد');
            const parsed = this.parse(response.data);
            if (parsed === -100 || parsed?.ISSessionExpired || parsed?.ISessionExpired) {
                this.otherService.removeLocalStorage();
                void this.router.navigate(['login']);
                throw new Error('لطفا وارد سیستم شوید');
            }
            return response;
        }
        finally {
            this.pendingRequests--;
        }
    }
    ngOnDestroy(): void {
        this.destroyed = true;
        this.closeRowMenu(false);
        this.destroy$.next();
        this.destroy$.complete();
        $(this.el.nativeElement).find('.modal').off('.vehicleRecords').modal('hide');
    }
}
